// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: xtfWGDm5314EDVZ9cvmE1G
// Component: XN7FKInTJXfD
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants,
} from "@plasmicapp/react-web";
import TextInput2 from "../../TextInput2"; // plasmic-import: wf0EastN9f_/component
import Button from "../../Button"; // plasmic-import: 5W9CbZmWGV-/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_alter_merch.module.css"; // plasmic-import: xtfWGDm5314EDVZ9cvmE1G/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: XN7FKInTJXfD/css

import Line5Icon from "./icons/PlasmicIcon__Line5"; // plasmic-import: 3Xyb6Q_Vc7c/icon
import Line6Icon from "./icons/PlasmicIcon__Line6"; // plasmic-import: 0M7vxWGIKEf/icon
import Vector2Icon from "./icons/PlasmicIcon__Vector2"; // plasmic-import: 0PJZJunuaAD/icon
import IconShareIcon from "./icons/PlasmicIcon__IconShare"; // plasmic-import: jDy_8IeKXuz/icon
import Line9Icon from "./icons/PlasmicIcon__Line9"; // plasmic-import: ns7mWEGL0fY/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: tz5FLb8Srop/icon
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: RmzuV1m7hJM/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: on5inL9tgye/icon
import image2I7GLlVst from "./images/image2.png"; // plasmic-import: I7g-LLVst/picture
import Messenger from "../../Messenger";
import TeeShirt from "../../TeeShirt";

import { loadStdlib } from "@reach-sh/stdlib";
import MyAlgoConnect from "@reach-sh/stdlib/ALGO_MyAlgoConnect";
import ConnectWalletButton from "./ConnectButton/ConnectWalletBtn";
import TransferFund from "./Transferfund";
import FundAccount from "./FundWallet";
import myalgo from "../../assets/images/myaglo-logo.png";
import { MyAlgoWalletMain } from "./MyAlgoWallet.styles";

const reach = loadStdlib("ALGO");

reach.setWalletFallback(
  reach.walletFallback({
    providerEnv: "TestNet",
    MyAlgoConnect,
  })
);

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  root?: p.Flex<"div">;
  home?: p.Flex<"div">;
  teeshirt?: p.Flex<"a">;
  teeShirt?: p.Flex<"div">;
  rectangle801?: p.Flex<"div">;
  rectangle804?: p.Flex<"div">;
  rectangle803?: p.Flex<"div">;
  rectangle802?: p.Flex<"div">;
  home2?: p.Flex<"div">;
  rectangle779?: p.Flex<"div">;
  rectangle805?: p.Flex<"div">;
  sweatshirts?: p.Flex<"div">;
  telegramLogo1?: p.Flex<"div">;
  twitter10?: p.Flex<"div">;
  twitter11?: p.Flex<"div">;
  yesNoProblem?: p.Flex<"div">;
  e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1?: p.Flex<"div">;
  a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1?: p.Flex<"div">;
  il570XN37562444589Z5BTransformed1?: p.Flex<"div">;
  ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81?: p.Flex<"div">;
  b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001?: p.Flex<"div">;
  il570XN1?: p.Flex<"div">;
  il340X2703782253999K7LkTransformed1?: p.Flex<"div">;
  il340X27037346764826J0WTransformed1?: p.Flex<"div">;
  ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1?: p.Flex<"div">;
  il340X2703984070216FrxfTransformed1?: p.Flex<"div">;
  il570XN2960743790L8XdTransformed1?: p.Flex<"div">;
  _6C4Bc2D236Af4BafAde1B6117E30A47C1?: p.Flex<"div">;
  textInput2?: p.Flex<typeof TextInput2>;
  img?: p.Flex<typeof p.PlasmicImg>;
};

export interface DefaultHomepageProps {
  className?: string;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants,
  };
  const getAccount = async () => {
    try {
      account.current = await reach.getDefaultAccount();
      setAccountAddress(account.current.networkAccount.addr);
      console.log("Account :" + account.current.networkAccount.addr);
    } catch (err) {
      console.log(err);
    }
  };

  const getBalance = async () => {
    try {
      let rawBalance = await reach.balanceOf(account.current);
      balance.current = reach.formatCurrency(rawBalance, 4);
      setAccountBal(balance.current);
      console.log("Balance :" + balance.current);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <React.Fragment>
      {}

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"home"}
            data-plasmic-override={overrides.home}
            className={classNames(projectcss.all, sty.home)}
          >
            <a
              data-plasmic-name={"teeshirt"}
              data-plasmic-override={overrides.teeshirt}
              className={classNames(projectcss.all, projectcss.a, sty.teeshirt)}
              href={`/tee-shirt`}
            >
              <div
                data-plasmic-name={"teeShirt"}
                data-plasmic-override={overrides.teeShirt}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.teeShirt
                )}
              >
                {"Tee-shirt"}
              </div>
            </a>

            <div
              data-plasmic-name={"rectangle801"}
              data-plasmic-override={overrides.rectangle801}
              className={classNames(projectcss.all, sty.rectangle801)}
            />

            <div
              data-plasmic-name={"rectangle804"}
              data-plasmic-override={overrides.rectangle804}
              className={classNames(projectcss.all, sty.rectangle804)}
            />

            <div
              data-plasmic-name={"rectangle803"}
              data-plasmic-override={overrides.rectangle803}
              className={classNames(projectcss.all, sty.rectangle803)}
            />

            <div
              data-plasmic-name={"rectangle802"}
              data-plasmic-override={overrides.rectangle802}
              className={classNames(projectcss.all, sty.rectangle802)}
            />

            <div
              data-plasmic-name={"home2"}
              data-plasmic-override={overrides.home2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.home2
              )}
            >
              {"Home "}
            </div>

            <Line5Icon
              className={classNames(projectcss.all, sty.svg__azRpp)}
              role={"img"}
            />

            <Line6Icon
              className={classNames(projectcss.all, sty.svg__z0A8F)}
              role={"img"}
            />

            <div
              data-plasmic-name={"rectangle779"}
              data-plasmic-override={overrides.rectangle779}
              className={classNames(projectcss.all, sty.rectangle779)}
            />

            <div
              data-plasmic-name={"rectangle805"}
              data-plasmic-override={overrides.rectangle805}
              className={classNames(projectcss.all, sty.rectangle805)}
            />

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__uvW7B
              )}
            >
              <React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ fontWeight: 400 }}
                >
                  {"Get your favorite merchandise in our "}
                </span>
                <React.Fragment>{"\n"}</React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ fontWeight: 400 }}
                >
                  {"marketplace "}
                </span>
                <React.Fragment>{"\n"}</React.Fragment>
                <span
                  className={"plasmic_default__all plasmic_default__span"}
                  style={{ fontWeight: 400 }}
                >
                  {"Sell what you don’t wear"}
                </span>
              </React.Fragment>
            </div>

            <div
              data-plasmic-name={"sweatshirts"}
              data-plasmic-override={overrides.sweatshirts}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.sweatshirts
              )}
            >
              {"Sweatshirts\n"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hWwIv
              )}
            >
              {"Jackets"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___6IXiF
              )}
            >
              {"Caps"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___9Gz5J
              )}
            >
              {"Hats"}
            </div>

            <div
              data-plasmic-name={"telegramLogo1"}
              data-plasmic-override={overrides.telegramLogo1}
              className={classNames(projectcss.all, sty.telegramLogo1)}
            />

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__sJe43
              )}
            >
              {"Help & Contact"}
            </div>

            <div
              data-plasmic-name={"twitter10"}
              data-plasmic-override={overrides.twitter10}
              className={classNames(projectcss.all, sty.twitter10)}
            />

            <div
              data-plasmic-name={"twitter11"}
              data-plasmic-override={overrides.twitter11}
              className={classNames(projectcss.all, sty.twitter11)}
            />

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__i9XB9
              )}
            >
              {"Follow us"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__zwUCi
              )}
            >
              {
                "Frequent Questions\nApplication Altermerch\nDelivery \nFollow my delivery"
              }
            </div>

            <Vector2Icon
              className={classNames(projectcss.all, sty.svg__wrXVw)}
              role={"img"}
            />

            <IconShareIcon
              className={classNames(projectcss.all, sty.svg__kYoau)}
              role={"img"}
            />

            <div
              data-plasmic-name={"yesNoProblem"}
              data-plasmic-override={overrides.yesNoProblem}
              className={classNames(projectcss.all, sty.yesNoProblem)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__blDli
                )}
              >
                {"Yes, no problem."}
              </div>
            </div>

            <Line9Icon
              className={classNames(projectcss.all, sty.svg__uWtdV)}
              role={"img"}
            />

            <div
              data-plasmic-name={
                "e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1"
              }
              data-plasmic-override={
                overrides.e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1
              }
              className={classNames(
                projectcss.all,
                sty.e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1
              )}
            />

            <div
              data-plasmic-name={
                "a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1"
              }
              data-plasmic-override={
                overrides.a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1
              }
              className={classNames(
                projectcss.all,
                sty.a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1
              )}
            />

            <div
              data-plasmic-name={"il570XN37562444589Z5BTransformed1"}
              data-plasmic-override={
                overrides.il570XN37562444589Z5BTransformed1
              }
              className={classNames(
                projectcss.all,
                sty.il570Xn37562444589Z5BTransformed1
              )}
            />

            <div
              data-plasmic-name={
                "ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81"
              }
              data-plasmic-override={
                overrides.ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81
              }
              className={classNames(
                projectcss.all,
                sty.ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81
              )}
            />

            <div
              data-plasmic-name={
                "b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001"
              }
              data-plasmic-override={
                overrides.b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001
              }
              className={classNames(
                projectcss.all,
                sty.b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001
              )}
            />

            <div
              data-plasmic-name={"il570XN1"}
              data-plasmic-override={overrides.il570XN1}
              className={classNames(projectcss.all, sty.il570Xn1)}
            />

            <div
              data-plasmic-name={"il340X2703782253999K7LkTransformed1"}
              data-plasmic-override={
                overrides.il340X2703782253999K7LkTransformed1
              }
              className={classNames(
                projectcss.all,
                sty.il340X2703782253999K7LkTransformed1
              )}
            />

            <div
              data-plasmic-name={"il340X27037346764826J0WTransformed1"}
              data-plasmic-override={
                overrides.il340X27037346764826J0WTransformed1
              }
              className={classNames(
                projectcss.all,
                sty.il340X27037346764826J0WTransformed1
              )}
            />

            <div
              data-plasmic-name={
                "ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1"
              }
              data-plasmic-override={
                overrides.ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1
              }
              className={classNames(
                projectcss.all,
                sty.ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1
              )}
            />

            <div
              data-plasmic-name={"il340X2703984070216FrxfTransformed1"}
              data-plasmic-override={
                overrides.il340X2703984070216FrxfTransformed1
              }
              className={classNames(
                projectcss.all,
                sty.il340X2703984070216FrxfTransformed1
              )}
            />

            <div
              data-plasmic-name={"il570XN2960743790L8XdTransformed1"}
              data-plasmic-override={
                overrides.il570XN2960743790L8XdTransformed1
              }
              className={classNames(
                projectcss.all,
                sty.il570Xn2960743790L8XdTransformed1
              )}
            />

            <div
              data-plasmic-name={"_6C4Bc2D236Af4BafAde1B6117E30A47C1"}
              data-plasmic-override={
                overrides._6C4Bc2D236Af4BafAde1B6117E30A47C1
              }
              className={classNames(
                projectcss.all,
                sty._6C4Bc2D236Af4BafAde1B6117E30A47C1
              )}
            />

            <TextInput2
              data-plasmic-name={"textInput2"}
              data-plasmic-override={overrides.textInput2}
              className={classNames("__wab_instance", sty.textInput2)}
            />

            <Button
              href="/teeshirt"
              className={classNames("__wab_instance", sty.button___7QizO)}
              link={`/messenger`}
            >
              {"Messenger"}
            </Button>

            <Button
              accountAddress={accountAddress}
              connectWallet={connectWallet}
              className={classNames("__wab_instance", sty.button___37Oyz)}
            >
              {"Connect your Wallet"}
            </Button>

            <p.PlasmicImg
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={"" as const}
              className={classNames(sty.img)}
              displayHeight={"208px" as const}
              displayMaxHeight={"none" as const}
              displayMaxWidth={"100%" as const}
              displayMinHeight={"0" as const}
              displayMinWidth={"0" as const}
              displayWidth={"230px" as const}
              link={"" as const}
              loading={"lazy" as const}
              src={{
                src: image2I7GLlVst,
                fullWidth: 500,
                fullHeight: 500,
                aspectRatio: undefined,
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "home",
    "teeshirt",
    "teeShirt",
    "rectangle801",
    "rectangle804",
    "rectangle803",
    "rectangle802",
    "home2",
    "rectangle779",
    "rectangle805",
    "sweatshirts",
    "telegramLogo1",
    "twitter10",
    "twitter11",
    "yesNoProblem",
    "e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1",
    "a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1",
    "il570XN37562444589Z5BTransformed1",
    "ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81",
    "b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001",
    "il570XN1",
    "il340X2703782253999K7LkTransformed1",
    "il340X27037346764826J0WTransformed1",
    "ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1",
    "il340X2703984070216FrxfTransformed1",
    "il570XN2960743790L8XdTransformed1",
    "_6C4Bc2D236Af4BafAde1B6117E30A47C1",
    "textInput2",
    "img",
  ],
  home: [
    "home",
    "teeshirt",
    "teeShirt",
    "rectangle801",
    "rectangle804",
    "rectangle803",
    "rectangle802",
    "home2",
    "rectangle779",
    "rectangle805",
    "sweatshirts",
    "telegramLogo1",
    "twitter10",
    "twitter11",
    "yesNoProblem",
    "e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1",
    "a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1",
    "il570XN37562444589Z5BTransformed1",
    "ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81",
    "b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001",
    "il570XN1",
    "il340X2703782253999K7LkTransformed1",
    "il340X27037346764826J0WTransformed1",
    "ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1",
    "il340X2703984070216FrxfTransformed1",
    "il570XN2960743790L8XdTransformed1",
    "_6C4Bc2D236Af4BafAde1B6117E30A47C1",
    "textInput2",
    "img",
  ],
  teeshirt: ["teeshirt", "teeShirt"],
  teeShirt: ["teeShirt"],
  rectangle801: ["rectangle801"],
  rectangle804: ["rectangle804"],
  rectangle803: ["rectangle803"],
  rectangle802: ["rectangle802"],
  home2: ["home2"],
  rectangle779: ["rectangle779"],
  rectangle805: ["rectangle805"],
  sweatshirts: ["sweatshirts"],
  telegramLogo1: ["telegramLogo1"],
  twitter10: ["twitter10"],
  twitter11: ["twitter11"],
  yesNoProblem: ["yesNoProblem"],
  e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1: [
    "e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1",
  ],
  a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1:
    [
      "a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1",
    ],
  il570XN37562444589Z5BTransformed1: ["il570XN37562444589Z5BTransformed1"],
  ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81:
    [
      "ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81",
    ],
  b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001: [
    "b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001",
  ],
  il570XN1: ["il570XN1"],
  il340X2703782253999K7LkTransformed1: ["il340X2703782253999K7LkTransformed1"],
  il340X27037346764826J0WTransformed1: ["il340X27037346764826J0WTransformed1"],
  ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1:
    [
      "ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1",
    ],
  il340X2703984070216FrxfTransformed1: ["il340X2703984070216FrxfTransformed1"],
  il570XN2960743790L8XdTransformed1: ["il570XN2960743790L8XdTransformed1"],
  _6C4Bc2D236Af4BafAde1B6117E30A47C1: ["_6C4Bc2D236Af4BafAde1B6117E30A47C1"],
  textInput2: ["textInput2"],
  img: ["img"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  home: "div";
  teeshirt: "a";
  teeShirt: "div";
  rectangle801: "div";
  rectangle804: "div";
  rectangle803: "div";
  rectangle802: "div";
  home2: "div";
  rectangle779: "div";
  rectangle805: "div";
  sweatshirts: "div";
  telegramLogo1: "div";
  twitter10: "div";
  twitter11: "div";
  yesNoProblem: "div";
  e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1: "div";
  a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1: "div";
  il570XN37562444589Z5BTransformed1: "div";
  ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81: "div";
  b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001: "div";
  il570XN1: "div";
  il340X2703782253999K7LkTransformed1: "div";
  il340X27037346764826J0WTransformed1: "div";
  ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1: "div";
  il340X2703984070216FrxfTransformed1: "div";
  il570XN2960743790L8XdTransformed1: "div";
  _6C4Bc2D236Af4BafAde1B6117E30A47C1: "div";
  textInput2: typeof TextInput2;
  img: typeof p.PlasmicImg;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps,
        }),
      [props, nodeName]
    );

    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    home: makeNodeComponent("home"),
    teeshirt: makeNodeComponent("teeshirt"),
    teeShirt: makeNodeComponent("teeShirt"),
    rectangle801: makeNodeComponent("rectangle801"),
    rectangle804: makeNodeComponent("rectangle804"),
    rectangle803: makeNodeComponent("rectangle803"),
    rectangle802: makeNodeComponent("rectangle802"),
    home2: makeNodeComponent("home2"),
    rectangle779: makeNodeComponent("rectangle779"),
    rectangle805: makeNodeComponent("rectangle805"),
    sweatshirts: makeNodeComponent("sweatshirts"),
    telegramLogo1: makeNodeComponent("telegramLogo1"),
    twitter10: makeNodeComponent("twitter10"),
    twitter11: makeNodeComponent("twitter11"),
    yesNoProblem: makeNodeComponent("yesNoProblem"),
    e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1: makeNodeComponent(
      "e68B4A6Acc8D1C866B79E79Ed618Fc2CRemovebgPreview1"
    ),
    a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1:
      makeNodeComponent(
        "a13UsaonutLAcCLa2140200051DfVcQYhLpng002140200000002140020000Sy350Ql65Transformed1"
      ),
    il570XN37562444589Z5BTransformed1: makeNodeComponent(
      "il570XN37562444589Z5BTransformed1"
    ),
    ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81:
      makeNodeComponent(
        "ssrcoLightweightSweatshirtMensBlackLightweightRaglanSweatshirtFrontSquareProductX600BgF8F8F81"
      ),
    b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001:
      makeNodeComponent(
        "b1I3U9QKsAcCLa21402000B137NywPqSpng002140200000002140020001"
      ),
    il570XN1: makeNodeComponent("il570XN1"),
    il340X2703782253999K7LkTransformed1: makeNodeComponent(
      "il340X2703782253999K7LkTransformed1"
    ),
    il340X27037346764826J0WTransformed1: makeNodeComponent(
      "il340X27037346764826J0WTransformed1"
    ),
    ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1:
      makeNodeComponent(
        "ssrcoBaseballCapProduct00000044F0B734A5FrontSquare600X600BgF8F8F8RemovebgPreview1"
      ),
    il340X2703984070216FrxfTransformed1: makeNodeComponent(
      "il340X2703984070216FrxfTransformed1"
    ),
    il570XN2960743790L8XdTransformed1: makeNodeComponent(
      "il570XN2960743790L8XdTransformed1"
    ),
    _6C4Bc2D236Af4BafAde1B6117E30A47C1: makeNodeComponent(
      "_6C4Bc2D236Af4BafAde1B6117E30A47C1"
    ),
    textInput2: makeNodeComponent("textInput2"),
    img: makeNodeComponent("img"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: "",
    },
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
